import React from 'react'

const VideoGallery = () => {
    const video1 = "https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054186/tdrzoh9j6wzevlkczh7x.mp4"
    const video2 = "https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054196/olkqcqaz4zxhvbzqlxys.mp4"
    const video3 = "https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054212/qxktduoo7nhpexjxmacj.mp4"
    const video4 = "https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054227/k3swqmkohhvek7qjsyfg.mp4"
    const video5 = "https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054243/ne4vs5x4or7lqf3uhfka.mp4"
    const video6 = "https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054258/lpmsgizzqeypln0egzge.mp4"

  return (
    <div className='videos-container'>
        <div className='videos'>
            <video
                src={video1}
                controls
            />

            <video
                src={video2}
                controls
            />

            <video
                src={video3}
                controls
            />

            <video
                src={video4}
                controls
            />

            <video
                src={video5}
                controls
            />

            <video
                src={video6}
                controls
            />
        </div>
    </div>
  )
}

export default VideoGallery